import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { ITiersService } from "@shared/interfaces/tiers-service.interface";
import { GetTiersListDto } from "@shared/types/tiers/get-tiers-list.dto";
import {
  CreateTierDto,
  TierDto,
  UpdateTierDto,
} from "@shared/types/tiers/tiers.dto";

@appInjectable()
export class TiersService extends BaseService implements ITiersService {
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  create: ITiersService["create"] = async (dto: CreateTierDto) => {
    const { data } = await this.httpClient.post<any>(
      "/tiers",
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data.data;
  };

  update: ITiersService["update"] = async (dto: UpdateTierDto) => {
    const { data } = await this.httpClient.patch<any>(
      `/tiers/${dto.id}`,
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data.data;
  };

  list: ITiersService["list"] = async (dto: GetTiersListDto) => {
    const { data } = await this.httpClient.get<any>("/tiers", {
      params: dto,
      baseURL: this.baseURL,
    });

    return data.data;
  };

  delete: ITiersService["delete"] = async (dto: TierDto) => {
    const { data } = await this.httpClient.delete<any>(`/tiers/${dto.id}`, {
      baseURL: this.baseURL,
    });
    return data.data;
  };

  get: ITiersService["get"] = async (id: string) => {
    const { data } = await this.httpClient.get<any>(`/tiers/${id}`, {
      baseURL: this.baseURL,
    });
    return data.data;
  };
}
